import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from "@/ui/select/Select";

// Filter Component
function ReviewsFilter({ selectedReviewSort, setSelectedReviewSort }) {
	const { t } = useTranslation();

	return (
		<Select
			value={selectedReviewSort}
			onValueChange={setSelectedReviewSort}
		>
			<SelectTrigger>
				<SelectValue placeholder={t("courses:sort.placeholder")} />
			</SelectTrigger>
			<SelectContent>
				<SelectGroup>
					<SelectLabel>{t("courses:sort.label")}</SelectLabel>
					<SelectItem value="most-recent">
						{t("courses:sort.newest")}
					</SelectItem>
					<SelectItem value="highest-rated">
						{t("reviews:reviewsFilter.highest")}
					</SelectItem>
					<SelectItem value="lowest-rated">
						{t("reviews:reviewsFilter.lowest")}
					</SelectItem>
				</SelectGroup>
			</SelectContent>
		</Select>
	);
}

export default ReviewsFilter;
